import { render } from "./requestView.vue?vue&type=template&id=2c53c347"
import script from "./requestView.vue?vue&type=script&lang=js"
export * from "./requestView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__